export const selectOutreachLoading = (state) => state?.outreach?.isLoading;
export const selectOutreach = (state) => state?.outreach?.data;
export const selectOutreachError = (state) => state?.outreach?.error;

export const selectOutreachCandidatePagination = (state) =>
  state?.outreach?.candidatePagination;

export const selectOutreachSearchTerm = (state) =>
  state?.outreach?.search?.term;
export const selectOutreachFilter = (state) => state?.outreach?.filters;
export const selectOutreachFilterChanged = (state) =>
  state?.outreach?.filters?.changed;
export const selectOutreachSort = (state) => state?.outreach?.sort;
